module.exports = {
  alignItems: { value: 'flex-start' },
  alignContent: { value: 'center' },
  flexDirection: { value: 'column' },
  justifyContent: { value: 'center' },
};
